// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';

import Svg, { SvgProps } from '../Svg';

const CircleExclamation: React.FC<SvgProps> = (props) => (
  <Svg width="20" height="20" viewBox="0 0 20 20" {...props}>
    <g data-name="グループ 50" transform="translate(-40 -80)">
      <circle
        data-name="楕円形 9"
        cx="10"
        cy="10"
        r="10"
        transform="translate(40 80)"
        fill="#ca0a37"
      />
      <path
        data-name="パス 13"
        d="M.756-9.66H2.73l-.336 6.44h-1.3zm.07 7.84H2.66V0H.826z"
        transform="translate(48.257 94.83)"
        fill="#fff"
      />
    </g>
  </Svg>
);

CircleExclamation.displayName = 'CircleExclamation';

export default CircleExclamation;
